import React from "react";
import { StyledCard } from "./styled.components";
import { StyledVideo } from "../../pages/shared.styled.components";

interface VideoCardProps {
  src: string;
  titleComponent: React.ReactElement;
}

const VideoCard: React.FC<VideoCardProps> = ({ src, titleComponent }) => {
  return (
    <StyledCard key={`video-card-${src}`.replace(" ", "")}>
      <StyledVideo src={src} />

      {titleComponent}
    </StyledCard>
  );
};

export default VideoCard;
